module.exports = __webpack_public_path__ + "img/KMS-J-18.e7189f25.svg";